/**
 * @exports ContentToggler
 */

/**
 * Wrapper for templating engine
 * @param {string} content
 */
function Template(content) {
		'use strict';
	this.content = content;
}

Template.prototype = {

	/**
	 * Data is required
	 * @param {object} data
	 * @param {object} options [optional]
	 * @return string
	 * @throws Error
	 */
	output: function (data) {
		'use strict';

		return eval(`(${this.content.trim().indexOf('function') === 0 ? '' : 'function'} ${this.content})`)(data);
	},
};

export default Template;